import React from "react";

const Hero = ({
  bgImage,
  box,
  imgStyle,
}: {
  bgImage: string;
  box: React.ReactChild;
  imgStyle?: any;
}) => {
  return (
    <div className={"hero"}>
      <div className={"container hero-container"}>
        {box && <div className={"hero-box"}>{box}</div>}
      </div>
      <img className={"hero-bg"} src={bgImage} style={imgStyle} />
    </div>
  );
};

export default Hero;
